import { SplitButton } from '@ori-ui/components';
import { Link, styled } from '@ori-ui/mui';
export var Root = styled('div')(function (_ref) {
  var theme = _ref.theme;
  return {
    margin: theme.spacing(3, 0)
  };
});
export var CopyLinkButton = styled(SplitButton)(function (_ref2) {
  var theme = _ref2.theme;
  return {
    '& .Mui-disabled': {
      backgroundColor: theme.palette.primary.dark,
      color: theme.palette.common.white
    },
    '& .OriMuiSplitButton-content': {
      position: 'relative',
      paddingLeft: theme.spacing(3),
      overflow: 'hidden'
    },
    '& .OriMuiSplitButton-button': {
      padding: theme.spacing(0, 4, 0, 3),
      whiteSpace: 'nowrap',
      width: 110
    }
  };
});
export var LinkContent = styled(Link)(function (_ref3) {
  var theme = _ref3.theme;
  return {
    display: 'flex',
    flex: '0 1 auto',
    position: 'relative',
    width: '100%',
    minWidth: 200,
    alignItems: 'center',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    fontWeight: 'bold',
    cursor: 'pointer',
    textDecoration: 'none',
    '&:hover': {
      color: theme.palette.primary.dark
    },
    '& .MuiSvgIcon-root': {
      paddingRight: theme.spacing(1)
    },
    '&::after': {
      display: 'block',
      position: 'absolute',
      width: 150,
      height: '100%',
      right: 0,
      content: '""',
      background: 'linear-gradient(to left, rgba(255, 255, 255, 1), rgba(255, 255, 255, 0))'
    }
  };
});
//# sourceMappingURL=styles.js.map